import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import ActivitySessionAttendeeTabs from '@activities/components/tabs/activity-session-attendee-tabs/activity-session-attendee-tabs.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';

@Component({
  name: 'bpc-enrollment',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
    'bpc-activity-session-attendee-tabs': ActivitySessionAttendeeTabs,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class ActivitySessionAttendeeWrapper extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
